<div class="w3-large" style="float: right;">
  <a (click)="close()">
    <mat-icon>close</mat-icon>
  </a>
</div>
<div class="accent h-20" fxLayoutAlign="start center">
  <span class=" h1 " mat-dialog-title>
    <strong>
      {{'PURCHASE_ORDER_MODULE.CONFIRM_CLOSE_PO_DIALOG_COMPONENT.TITLE' | translate }}
    </strong>
  </span>
</div>
<div>

  <span *ngIf="data.pendingInventory >0" style="color: rgb(233, 32, 32);;">
    <mat-icon>warning</mat-icon>
    <br>
    {{'PURCHASE_ORDER_MODULE.CONFIRM_CLOSE_PO_DIALOG_COMPONENT.WARNING_MSG' | translate }}

  </span>
</div>
<br>
<div>
  <mat-form-field appearance="outline" class="pr-4 orderInputForm">
    <mat-label> {{'PURCHASE_ORDER_MODULE.CONFIRM_CLOSE_PO_DIALOG_COMPONENT.REFERENCE_NUMBER' | translate }}
    </mat-label>
    <input matInput [(ngModel)]='data.referenceNumber'>
    <mat-icon matSuffix
      matTooltip="{{'PURCHASE_ORDER_MODULE.CONFIRM_CLOSE_PO_DIALOG_COMPONENT.REFERENCE_NUMBER' | translate }}">
      information
    </mat-icon>
  </mat-form-field>
</div>
<div class="p-8">
  <div mat-dialog-actions>
    <button class="btn btn-primary" [disabled]="data.pendingInventory >0" [mat-dialog-close]="data">
      {{'PURCHASE_ORDER_MODULE.CONFIRM_CLOSE_PO_DIALOG_COMPONENT.BUTTONS.CONFIRM' | translate }}
    </button>
    &nbsp;

    <button class="btn btn-secondary" (click)="dialogRef.close(false)">

      {{'PURCHASE_ORDER_MODULE.CONFIRM_CLOSE_PO_DIALOG_COMPONENT.BUTTONS.CANCEL' | translate }}

    </button>


  </div>
</div>
